import {Permissions} from '@/core/config/enums/Permissions'
import { Paths,Names } from '@/core/config/enums/SitePaths';
const DocMenuConfig = [
  {
      heading: "DASHBOARD",
    
      route: "/",
      pages: [
          {
          heading: "Dashboard",
          route: Paths.DASHBOARD,
          svgIcon: "/media/icons/duotune/ecommerce/ecm001.svg",
          fontIcon: "bi-layers",                  
        },
      ]
  },  
  {
    
    heading: "SHOP",
    permission: Permissions.SHOP_PERMISSIONS,
    route: "/",
    pages: [
      {
        heading: "Products",
        route: Paths.PRODUCTS,
        svgIcon: "/media/icons/duotune/ecommerce/ecm001.svg",
        fontIcon: "bi-layers",        
         
      },
       {
        heading: "Product Attributes",
        route: Paths.PRODUCT_ATTRIBUTES,
        svgIcon: "/media/icons/duotune/ecommerce/ecm001.svg",
        fontIcon: "bi-layers",        
         
      },
      {
          heading:"Categories",
          route: Paths.CATEGORIES,
          svgIcon: "/media/icons/duotune/electronics/elc002.svg",
            
        },
        {
          heading:"Catalogue",
          route: Paths.CATALOGUE_PAGE,
          svgIcon: "/media/icons/duotune/ecommerce/ecm001.svg",
        },      
     
      
    ],
  },
  {
    
    heading: "Sales",
    permission: Permissions.ORDERS_PERMISSIONS,
    route: "/",
    pages: [
        {
          heading:"Orders",
          route: Paths.ORDERS,
          svgIcon: "/media/icons/duotune/ecommerce/ecm001.svg",
        },
    ],
  },
  {
    heading: "Client",
    permission: Permissions.CLIENTS_PERMISSIONS,
    route: "/clients",
    pages: [
       {
        heading: "Clients",
        route: Paths.CLIENTS,
        svgIcon: "/media/icons/duotune/finance/fin006.svg",
        fontIcon: "bi-printer",
       
      },
      {
        heading: "Commissions",
        route: Paths.CLIENTS_COMMISSIONS,
        svgIcon: "/media/icons/duotune/finance/fin006.svg",
        fontIcon: "bi-printer",
       
      },
     
    ]
  },
  {
    heading: "User",
    route: "/users",
    permission: Permissions.USERS_PERMISSIONS,
    pages: [
      {
        heading: "Users",
        route: Paths.USERS,
        svgIcon: "/media/icons/duotune/finance/fin006.svg",
        fontIcon: "bi-printer",
        
      },
       {
        heading: "Roles",
        route: Paths.ROLES,
        svgIcon: "/media/icons/duotune/finance/fin006.svg",
        fontIcon: "bi-printer",
        
      },
    ],
  },
   {
    heading: "Configuration",
    permission: Permissions.STORE_PERMISSIONS,
    pages: [
      {
        heading: "Vat",
        route: Paths.VAT,
        svgIcon: "/media/icons/duotune/finance/fin006.svg",
        fontIcon: "bi-printer",
        
      },
      {
        heading: "Client Types",
        route: Paths.CLIENT_TYPES,
        svgIcon: "/media/icons/duotune/finance/fin006.svg",
        fontIcon: "bi-printer",
       
      },
    ],
  },
  
];

export default DocMenuConfig;
